import http from 'utils/request'
import type { ResponseModel, ResponsePaginationDataModel } from './base-model'

export function getVotesDetailList(meeting_id:string,vote_id:string,pageNum:number=0,pageSize:number=100000) { 
  return http.Post<ResponseModel<ResponsePaginationDataModel<any>>>(
    `/${meeting_id}/votesDetailList`,
    { vote_id, pageNum, pageSize }
  )  
}

export function getVotesAccountList(meeting_id:string,vote_id:string,pageNum:number=0,pageSize:number=100000) { 
  return http.Post<ResponseModel<ResponsePaginationDataModel<any>>>(
    `/${meeting_id}/votesAccountList`,
    { vote_id, pageNum, pageSize }
  )  
}

export function getVotesList(meeting_id:string) {
  return http.Get<ResponseModel>(
    `/${meeting_id}/votesList`
  )
}

export function getVotesStat(meeting_id:string,vote_id:string) {
  return http.Get<ResponseModel<any>>(
    `/${meeting_id}/votes/${vote_id}/stat`
  )
}

export function getVotesQuery(meeting_id:string) {
  return http.Post<ResponseModel<any>>(
    `info/meeting/${meeting_id}/voteQuery`
  )
}

export function getCheckinQuery(meeting_id:string) {
  return http.Post<ResponseModel<any>>(
    `info/meeting/${meeting_id}/checkinQuery`
  )
}